// import { asyncRoutes, constantRoutes } from '@/router'
import { constantRoutes } from '@/router'
import router from '@/router'
import { resetRouter } from '@/router'
import {localRoutes, page404 } from '@/router'
/**
 * Use meta.role to determine if the current user has permission
 * @param roles
 * @param route
 */
// function hasPermission(roles, route) {
//   if (route.meta && route.meta.roles) {
//     return roles.some(role => route.meta.roles.includes(role))
//   } else {
//     return true
//   }
// }

/**
 * Filter asynchronous routing tables by recursion
 * @param routes asyncRoutes
 * @param roles
 */
// export function filterAsyncRoutes(routes, roles) {
  // const res = []

  // routes.forEach(route => {
  // const tmp = { ...route }
  // if (hasPermission(roles, tmp)) {
  //   if (tmp.children) {
  //     tmp.children = filterAsyncRoutes(tmp.children, roles)
  //   }
  //   res.push(tmp)
  // }
  // })

  // return routes
// }
let arr = []
export function filterArr(list) {
  list.forEach(item => {
    if (item.children) {
      filterArr(item.children)
    } else {
      arr.push(item)
    }
  })
  // for (var i = 0; i < list.length; i++) {
  //   var data = list[i]
  //   if (data.children) {
  //     filterArr(data.children)
  //   } else {
  //     arr.push(data)
  //   }
  // }
  return arr
}

const state = {
  routes: [],
  addRoutes: [],
  nowRouter: '',
  allRouter: []

}

const mutations = {
  SET_ROUTES: (state, routes) => {
    state.addRoutes = routes
    // state.routes = constantRoutes.concat(routes)
    state.routes = routes
  },
  SET_NOWROUTE: (state, routes) => {
    state.nowRouter = routes
  },
  SET_ALLROUTES: (state, routes) => {
    state.allRouter = routes
  }
}

const actions = {
  powers({ commit }, route) {
    return new Promise(resolve => {
      commit('SET_NOWROUTE', route || '')
      resolve()
    })
  },
  generateRoutes({ commit }, routeData) {
    return new Promise(resolve => {
      // const acc = filterArr(routeData)

      // console.log(acc,'acc')
      // commit('SET_ALLROUTES', acc || [])
      commit('SET_ALLROUTES', routeData || [])
      arr = []
      const addRoutes = []
      // let tempPath = ''
      let tempList = []
      // 路由匹配 这里只做了两层的路由处理
      constantRoutes.forEach(item1 => {
        // tempPath = item1.path || ''
        tempList = []
        if (item1.children) {
          item1.children.forEach(item2 => {
            const obj = state.allRouter.find(o => o === item2.path)

            if (obj) {
              // item2.meta.power = obj.power
              tempList.push(item2)
            }
            // tempList.push(item2)
          })
        }
        if (tempList.length > 0) {
          addRoutes.push(Object.assign({}, item1, {
            children: tempList
          }))
        }
      })
      // console.log(addRoutes)
      // router.addRoutes(addRoutes)
      resetRouter()
      router.addRoutes(addRoutes)
      router.addRoutes(localRoutes)
      router.addRoutes(page404)
      commit('SET_ROUTES', addRoutes || [])
      resolve(addRoutes)
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
